(function (upp) {
    'use strict';

    var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE;
    upp.service('shippingChargesService', ['appi', '$q',
        function (appi, $q) {
            var cachedShippingCharges;

            /**
             * Returns a list of shipping charges
             *
             * @returns {Promise} Returns a promise that will be fulfilled or rejected
             */
            var getShippingCharges = function() {
                if (cachedShippingCharges) {
                    return $q.when(cachedShippingCharges)
                }

                return appi.http.get(URL_API_REST_SERVER + 'v2/shipping-charges')
                    .then(function (response) {
                        var result = {
                            shippingCharges: response.data['shippingCharges'],
                            fixedShippingCharges: response.data['fixedShippingCharges']
                        };
                        cachedShippingCharges = angular.copy(result);
                        return result
                    })
            };

            return {
                get: getShippingCharges
            };
        }]);
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/cart/services/shippingCharges-services.js